import React, { useEffect, useRef } from "react";
import useStyles from "./styles";
import { useDispatch } from "react-redux";
import { getDashboardStatistics } from "../../redux/actions/dashboard";
import { getCookie } from "../../services/cookie";
import StatisticsCard from "../Dashboard/Statistics/StatisticsCard";
import { useSelector } from "react-redux";

export const GridLayout = ({
  type,
  components,
  tab,
  canShowEnvtab,
  isWidgetPanelOpen,
  filter,
}) => {
  const classes = useStyles();
  const statisticsData =
    useSelector((s) => s.dashboard?.getStatistics?.data) || {};

  // map your card names to the keys in the API response
  const STAT_KEY_BY_NAME = {
    "Total Users": "user_statistics",
    "Total Facilities": "facility_statistics",
    "Total Assessment Cycles": "total_assessment_cycle_stats",
    "Total Audits": "total_audit_stats",
    "Total Tickets": "total_ticket_stats",
    "Total Records": "total_records_stats",
  };

  const dispatch = useDispatch();
  const firedRef = useRef(false);
  const role = getCookie("role");

  const hasStatistics =
    Array.isArray(components) &&
    components.some(
      (c) => c?.keyword === "statistics" || c?.graphComponent === StatisticsCard
    );

  const filterKey = JSON.stringify(filter || {});

  useEffect(() => {
    firedRef.current = false;
  }, [filterKey]);

  useEffect(() => {
    if (firedRef.current) return;
    if (!hasStatistics) return;
    if (role === "read_only_user") return;

    firedRef.current = true;
    dispatch(getDashboardStatistics(filter || {}));
  }, [hasStatistics, role, tab, dispatch, filterKey]);

  const getComponentsPerRow = () => {
    switch (type) {
      case 1:
        return 2;
      case 2:
        return 1;
      case 3:
        return 2;
      case 4:
        return 2;
      case 5:
        return 2;
      case 6:
        return 2;
      default:
        return 2;
    }
  };

  const componentsPerRow = getComponentsPerRow();

  const getClassForComponent = (index) => {
    if (type === 5) {
      return index % 2 === 0 ? classes.column8 : classes.column4;
    } else if (type === 6) {
      return index % 2 === 0 ? classes.column4 : classes.column8;
    } else {
      return classes.column;
    }
  };

  const rows = [];

  const filterComponent = components.find(
    (component) => component.name === "Filters"
  );
  const widgetComponents = components.filter(
    (component) => component.graphComponent === StatisticsCard
  );
  const otherComponentsSmall = components.filter(
    (component) =>
      component.name !== "Filters" &&
      component.graphComponent !== StatisticsCard &&
      (component.size === "m" || component.size === "s")
  );
  const otherComponentsLarge = components.filter(
    (component) =>
      component.name !== "Filters" &&
      component.graphComponent !== StatisticsCard &&
      component.size === "l"
  );

  if (filterComponent) {
    rows.push([filterComponent]);
  }

  if (widgetComponents.length > 0) {
    for (let i = 0; i < widgetComponents.length; i += 5) {
      rows.push(widgetComponents.slice(i, i + 5));
    }
  }

  for (let i = 0; i < otherComponentsSmall.length; i += componentsPerRow) {
    rows.push(otherComponentsSmall.slice(i, i + componentsPerRow));
  }

  for (let i = 0; i < otherComponentsLarge.length; i += 1) {
    rows.push(otherComponentsLarge.slice(i, i + 1));
  }

  return (
    <div className={classes.gridContainer}>
      {rows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className={isWidgetPanelOpen ? classes.rowAdjusted : classes.row}
        >
          {row.map((component, colIndex) => (
            <div
              key={colIndex}
              className={
                component.name === "Filters"
                  ? classes.eachGraphF
                  : component.graphComponent === StatisticsCard
                  ? classes.eachGraphStatistics
                  : component.size === "l"
                  ? classes.columnType2
                  : type === 1 || type === 3 || type === 4
                  ? classes.columnType3
                  : type === 2
                  ? classes.columnType2
                  : getClassForComponent(colIndex)
              }
            >
              {(() => {
                const isStatistics =
                  component.keyword === "statistics" ||
                  component.graphComponent === StatisticsCard;

                let mergedData = { ...(component.data || {}) };

                if (isStatistics) {
                  const statKey = STAT_KEY_BY_NAME[component.name];
                  const fromApi = statKey && statisticsData?.[statKey]?.prop;

                  if (fromApi) {
                    mergedData.title = fromApi.title ?? mergedData.title;
                    mergedData.value = fromApi.value ?? mergedData.value;
                  }
                }

                return (
                  <component.graphComponent
                    {...mergedData}
                    refreshContent={[2, 3].includes(tab)}
                    canShowEnvtab={canShowEnvtab}
                  />
                );
              })()}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
